<h3>{{ isFormEnabled ? "Enter Search Criteria" : "Search Criteria Review" }}</h3>
<div class="padding">
  <form [formGroup]="searchCriteriaDetails">
    @if (shouldDisplayExactSimilar) {
      <div class="flex-container">
        <div class="flex-item form-field">
          <mat-radio-group [formControlName]="'exactSimilar'" name="exact-similar"
            [attr.aria-label]="'orders.exactOrSimilarsRadioOption' | transloco">
            <mat-radio-button class="radio-button" [value]="false">{{ 'orders.includeSimilars' | transloco }} @if (displayIndividualFields && shouldDisplaySpecificNonSpecific) {
              <span>{{ 'orders.nonSpecific' | transloco }}</span>
            }</mat-radio-button>
            <mat-radio-button class="radio-button" [value]="true">{{ 'orders.exactOnly' | transloco }} @if (displayIndividualFields && shouldDisplaySpecificNonSpecific) {
              <span>{{ 'orders.specific' | transloco }}</span>
            }</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    }

    <div class="flex-container">
      <div class="flex-item form-field">
        <mat-radio-group [formControlName]="'partyTypeID'" name="party-type"
          [attr.aria-label]="'orders.debtorIndividualOrBusinessRadioOption' | transloco">
          <mat-radio-button class="radio-button" [value]="individualDebtor">{{ 'orders.individualDebtor' | transloco }}</mat-radio-button>
          <mat-radio-button class="radio-button" [value]="businessDebtor">{{ 'orders.businessDebtor' | transloco }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    @if (displayIndividualFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
            <input matInput [formControlName]="'firstName'" name="first-name" [placeholder]="'common.labels.firstName' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="searchCriteriaDetails.get('firstName')!"
          [message]="firstNameError$"></lib-error-bubble>
        </div>
        @if (!shouldDisplaySpecificNonSpecific || (shouldDisplaySpecificNonSpecific && searchCriteriaDetails.get('exactSimilar')!.value == true)) {
          <div
            class="validated-form-field-container flex-container">
            <mat-form-field class="flex-item form-field" appearance="outline">
              <mat-label>{{ (shouldOnlyAllowMiddleInitial ? 'orders.middleInitial' : 'common.labels.middleName') | transloco }}</mat-label>
              <input matInput [formControlName]="'middleName'" name="middle-name"
                placeholder="{{ (shouldOnlyAllowMiddleInitial ? 'orders.middleInitial' : 'common.labels.middleName') | transloco }}">
            </mat-form-field>
            <lib-error-bubble [control]="searchCriteriaDetails.get('middleName')!"
            [message]="middleNameError$"></lib-error-bubble>
          </div>
        }
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
            <input matInput [formControlName]="'lastName'" name="last-name" [placeholder]="'common.labels.lastName' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="searchCriteriaDetails.get('lastName')!"
          [message]="lastNameError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (displayIndividualFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          @if (shouldDisplayDateOfBirth) {
            <mat-form-field
              class="form-field flex-item" appearance="outline">
              <mat-label>{{ 'orders.birthDate' | transloco }}</mat-label>
              <input matInput [matDatepicker]="dateOfBirth" [formControlName]="'dateOfBirth'" name="date-of-birth"
                [placeholder]="'common.labels.yyyyMmDd' | transloco">
              <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
              <mat-datepicker #dateOfBirth></mat-datepicker>
            </mat-form-field>
          }
          <lib-error-bubble [control]="searchCriteriaDetails.get('dateOfBirth')!"
          [message]="dateOfBirthError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (displayBusinessFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.businessName' | transloco }}</mat-label>
            <input matInput [formControlName]="'busName'" name="business-name" [placeholder]="'common.labels.businessName' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="searchCriteriaDetails.get('busName')!"
          [message]="busNameError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (shouldDisplayPostalCode || shouldDisplaySearchFromDate) {
      <mat-expansion-panel
        [expanded]="shouldExpandAdditionalParameters()" (click)="this.hasUserExpandedAdditionalParameters = true" class="mat-elevation-z0"
        #panel="matExpansionPanel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>{{ 'orders.additionalParameters' | transloco }}</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (shouldDisplayPostalCode) {
          <div class="flex-container">
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="flex-item form-field" appearance="outline">
                <mat-label>{{ 'common.labels.postalCode' | transloco }}</mat-label>
                <input matInput [formControlName]="'postalCode'" name="postal-code" [placeholder]="'common.labels.postalCode' | transloco">
              </mat-form-field>
              <lib-error-bubble [control]="searchCriteriaDetails.get('postalCode')!"
              [message]="postalCodeError$"></lib-error-bubble>
            </div>
          </div>
        }
        @if (shouldDisplaySearchFromDate) {
          <div class="flex-container">
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="form-field flex-item" appearance="outline">
                <mat-label>{{ 'orders.excludeRegistrationsPreviousTo' | transloco }}</mat-label>
                <input matInput [matDatepicker]="searchFromDate" [formControlName]="'searchFromDate'"
                  name="search-from-date" [placeholder]="'common.labels.yyyyMmDd' | transloco">
                <mat-datepicker-toggle matSuffix [for]="searchFromDate"></mat-datepicker-toggle>
                <mat-datepicker #searchFromDate></mat-datepicker>
              </mat-form-field>
              <lib-error-bubble [control]="searchCriteriaDetails.get('searchFromDate')!"
              [message]="searchFromDateError$"></lib-error-bubble>
            </div>
          </div>
        }
        <br />
        <br />
      </mat-expansion-panel>
    }
  </form>
</div>